<!--Todo Fix after RunDocuments are back in the Gateway-->
<template>
  <v-container>
    <h1 v-if='runDocuments.length <= 1'>Handbuch</h1>
    <h1 v-else-if='runDocuments.length > 1'>Handbücher</h1>
    <template v-if='runDocuments.length > 0'>
      <v-expansion-panels accordion='accordion' v-model='panel'>
        <v-expansion-panel v-for='item in runDocuments' :key='`manual_${item.id}`'>
          <v-expansion-panel-header>
            <div><v-icon class='pr-2 primary--text'>mdi-file-pdf</v-icon>{{item.name}}</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content style='height: 66vh'>
            <Pdf :pdf-url="item.url"/>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </template>
    <div style="height: 66vh" v-else>
      <div>Kein Handbuch verfügbar</div>
    </div>

  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import Pdf from './Pdf.vue';

export default {
  name: 'Manual',
  components: {
    Pdf,
  },
  data() {
    return {
      editor: null,
      penInk: '',
      observationData: null,
      currentObservation: {},
      panel: 0
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      runInfo: (state) => state.runInfo,
      runDocuments: (state) => state.runInfo.documents,
    }),
  },
  methods: {},
  mounted() {},
  beforeDestroy() {},
};
</script>
